import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import TradeShowImageOne from "../../../assets/homepage/navbar/tradeShowOne.png";
import TradeShowImageTwo from "../../../assets/homepage/navbar/tradeShowTwo.png";
import TradeShowImageThree from "../../../assets/homepage/navbar/tradeShowThree.png";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

import "./style.css";

// import required modules
import { FreeMode, Pagination } from "swiper/modules";

// import './styles.css';

const NavbarSwiperComponent = () => {
  return (
    <div className=" w-full h-[207px] mt-[18px]">
      <Swiper
        className="TradeSlide"
        slidesPerView={3}
        spaceBetween={30}
        freeMode={true}
        pagination={{
          clickable: true,
        }}
        modules={[FreeMode, Pagination]}
      >
        <SwiperSlide className="miniSliders">
          <button>
            <div className="flex border items-center rounded-[6px] w-[402px] h-[181px] py-[40px] px-[20px] gap-x-4 text-left">
              <div>
                <img
                  src={TradeShowImageOne}
                  className="w-[100px] h-[100px]"
                  alt="TradeShowImg"
                />
              </div>
              <div className="flex flex-col gap-y-3">
                <p className="w-[92px] h-[25px] font-semibold text-[14px] text-black text-start">
                  Trade Show 1
                </p>

                <div className="flex gap-x-2 items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
                    />
                  </svg>

                  <p className="w-[151px] h-[18px] font-semibold text-[12px] text-black text-start">
                    28 Feb 2024 - 2 Mar 2024
                  </p>
                </div>

                <div className="flex gap-x-2 items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
                    />
                  </svg>

                  <p className="w-[105px] h-[18px] font-semibold text-[12px] text-black text-start">
                    Bandra, Mumbai
                  </p>
                </div>
              </div>
            </div>
          </button>
        </SwiperSlide>

        <SwiperSlide className="miniSliders">
          <button>
            <div className="flex border items-center rounded-[6px] w-[402px] h-[181px] py-[40px] px-[20px] gap-x-4 text-left">
              <div>
                <img
                  src={TradeShowImageTwo}
                  className="w-[100px] h-[100px]"
                  alt="TradeShowImg"
                />
              </div>
              <div className="flex flex-col gap-y-3">
                <p className="w-[92px] h-[25px] font-semibold text-[14px] text-black text-start">
                  Trade Show 1
                </p>

                <div className="flex gap-x-2 items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
                    />
                  </svg>

                  <p className="w-[151px] h-[18px] font-semibold text-[12px] text-black text-start">
                    28 Feb 2024 - 2 Mar 2024
                  </p>
                </div>

                <div className="flex gap-x-2 items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
                    />
                  </svg>

                  <p className="w-[105px] h-[18px] font-semibold text-[12px] text-black text-start">
                    Bandra, Mumbai
                  </p>
                </div>
              </div>
            </div>
          </button>
        </SwiperSlide>

        <SwiperSlide className="miniSliders">
          <button>
            <div className="flex border items-center rounded-[6px] w-[402px] h-[181px] py-[40px] px-[20px] gap-x-4 text-left">
              <div>
                <img
                  src={TradeShowImageThree}
                  className="w-[100px] h-[100px]"
                  alt="TradeShowImg"
                />
              </div>
              <div className="flex flex-col gap-y-3">
                <p className="w-[92px] h-[25px] font-semibold text-[14px] text-black text-start">
                  Trade Show 1
                </p>

                <div className="flex gap-x-2 items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
                    />
                  </svg>

                  <p className="w-[151px] h-[18px] font-semibold text-[12px] text-black text-start">
                    28 Feb 2024 - 2 Mar 2024
                  </p>
                </div>

                <div className="flex gap-x-2 items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
                    />
                  </svg>

                  <p className="w-[105px] h-[18px] font-semibold text-[12px] text-black text-start">
                    Bandra, Mumbai
                  </p>
                </div>
              </div>
            </div>
          </button>
        </SwiperSlide>

        <SwiperSlide className="miniSliders">
          <button>
            <div className="flex border items-center rounded-[6px] w-[402px] h-[181px] py-[40px] px-[20px] gap-x-4 text-left">
              <div>
                <img
                  src={TradeShowImageOne}
                  className="w-[100px] h-[100px]"
                  alt="TradeShowImg"
                />
              </div>
              <div className="flex flex-col gap-y-3">
                <p className="w-[92px] h-[25px] font-semibold text-[14px] text-black text-start">
                  Trade Show 1
                </p>

                <div className="flex gap-x-2 items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
                    />
                  </svg>

                  <p className="w-[151px] h-[18px] font-semibold text-[12px] text-black text-start">
                    28 Feb 2024 - 2 Mar 2024
                  </p>
                </div>

                <div className="flex gap-x-2 items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
                    />
                  </svg>

                  <p className="w-[105px] h-[18px] font-semibold text-[12px] text-black text-start">
                    Bandra, Mumbai
                  </p>
                </div>
              </div>
            </div>
          </button>
        </SwiperSlide>

        <SwiperSlide className="miniSliders">
          <button>
            <div className="flex border items-center rounded-[6px] w-[402px] h-[181px] py-[40px] px-[20px] gap-x-4 text-left">
              <div>
                <img
                  src={TradeShowImageTwo}
                  className="w-[100px] h-[100px]"
                  alt="TradeShowImg"
                />
              </div>
              <div className="flex flex-col gap-y-3">
                <p className="w-[92px] h-[25px] font-semibold text-[14px] text-black text-start">
                  Trade Show 1
                </p>

                <div className="flex gap-x-2 items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
                    />
                  </svg>

                  <p className="w-[151px] h-[18px] font-semibold text-[12px] text-black text-start">
                    28 Feb 2024 - 2 Mar 2024
                  </p>
                </div>

                <div className="flex gap-x-2 items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
                    />
                  </svg>

                  <p className="w-[105px] h-[18px] font-semibold text-[12px] text-black text-start">
                    Bandra, Mumbai
                  </p>
                </div>
              </div>
            </div>
          </button>
        </SwiperSlide>

        <SwiperSlide className="miniSliders">
          <button>
            <div className="flex border items-center rounded-[6px] w-[402px] h-[181px] py-[40px] px-[20px] gap-x-4 text-left">
              <div>
                <img
                  src={TradeShowImageThree}
                  className="w-[100px] h-[100px]"
                  alt="TradeShowImg"
                />
              </div>
              <div className="flex flex-col gap-y-3">
                <p className="w-[92px] h-[25px] font-semibold text-[14px] text-black text-start">
                  Trade Show 1
                </p>

                <div className="flex gap-x-2 items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
                    />
                  </svg>

                  <p className="w-[151px] h-[18px] font-semibold text-[12px] text-black text-start">
                    28 Feb 2024 - 2 Mar 2024
                  </p>
                </div>

                <div className="flex gap-x-2 items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
                    />
                  </svg>

                  <p className="w-[105px] h-[18px] font-semibold text-[12px] text-black text-start">
                    Bandra, Mumbai
                  </p>
                </div>
              </div>
            </div>
          </button>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default NavbarSwiperComponent;
